import React, { createContext, useContext, useState, useEffect ,useCallback} from "react";
import axios from "axios";
import PropTypes from "prop-types"; // Import PropTypes
import { logo } from "../_components/Imagepath";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const [credLoading, setCredLoading] = useState(false);



  useEffect(() => {

    const token = localStorage.getItem("authToken");
    if (token) {
      //getUser()
      verifyToken(token);//no need its done autmatically through  headers: { Authorization: `Bearer ${authToken}` },
    } else {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    if (!user) return;
  
    user.id && localStorage.setItem("id", user.id);
    user.name && localStorage.setItem("name", user.name);
    user.role && localStorage.setItem("role", user.role);
    user.type && localStorage.setItem("type", user.type);
    user.email && localStorage.setItem("email", user.email);
    user.token && localStorage.setItem("authToken", user.token);
    user.company.name && localStorage.setItem("company_name", user.company.name);
    user.company?.id && localStorage.setItem("idcompany", user.company.id);
    user.company?.logo && localStorage.setItem("logo", user.company.logo);
    user.company?.is_premium && localStorage.setItem("is_premium", user.company.is_premium);
    user.company.country && localStorage.setItem("country", user.company.country);
    user.super && localStorage.setItem("super", user.super);

  }, [user]);
  
/*
  const getUser = useCallback(async () => {
    const usernameCheck = localStorage.getItem("name");
  
    if (!usernameCheck) {
      try {
        const response = await axios.get("http://127.0.0.1:8000/api/auth/user/", {
          headers: { Authorization: `Bearer ${authToken}` },
        });
  
        setUser(response.data); // Set user from API response
      } catch (error) {
        console.error("Failed to fetch user:", error);
        logout();
      }
    }
  }, []);

  useEffect(() => {
    getUser();
  }, [getUser]);
  */
  //  Token verification function
  const verifyToken = async (token) => {
    try {
      
      const response = await axios.post(process.env.REACT_APP_BASE_URL+"/auth/token/verify/", { token });
      
      


      if (response.status === 200) {        
        setUser((prevUser) => ({
          id:localStorage.getItem("id") ,
          name:localStorage.getItem("name") ,
          role:localStorage.getItem("role"),
          type:localStorage.getItem("type"),
          super:localStorage.getItem("super"), 
          email:localStorage.getItem("email"), // Preserve existing user data
          token: localStorage.getItem("authToken"), // Update only the token


          company:{id:localStorage.getItem("idcompany"),
            logo:localStorage.getItem("logo")?localStorage.getItem("logo"):null,
            name:localStorage.getItem("company_name")?localStorage.getItem("company_name"):null,
            is_premium:localStorage.getItem("is_premium")?localStorage.getItem("is_premium"):null,
            country:localStorage.getItem("country")
          },
        }));  
    
      } else {
    
        logout();
      }
    } catch (error) {

      console.error("Token verification failed:", error);
      logout();
    } finally {
    
      setLoading(false);
    }
  };
 //register function
 const register = async (pageType,credentials,callback) => {

 
  let urlRegister;
  if(pageType === "agency-staff"){
    urlRegister="/auth/register-agency-staff/"

  }else if(pageType === "supplier-admin"){
    urlRegister="/auth/register-supplier-admin/"

  }else if(pageType === "agency-admin"){
      urlRegister="/auth/register-agency-admin/"

  }else if(pageType === "supplier-staff"){
      urlRegister="/auth/register-supplier-staff/"

  }else return

  setCredLoading(true)
  if(credLoading)return
  try { 
    const response = await axios.post(process.env.REACT_APP_BASE_URL+urlRegister, credentials, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const { access, refresh ,role , type, verified,company} = response.data;
    
   
    localStorage.setItem("authToken", access);
    localStorage.setItem("refreshToken", refresh);
     /*
    Done in useEffect
    localStorage.setItem("name", credentials?.name);
    localStorage.setItem("email", credentials?.email);
    localStorage.setItem("role", capitalizeFirstLetter(role));
    localStorage.setItem("type", type);
    localStorage.setItem("verified", verified);
    localStorage.setItem("idcompany",company)
    */

    setUser({ name:credentials?.name ,
      email:credentials?.email
       ,token: access ,
       type:type,
       super:false,
       role:capitalizeFirstLetter(role),
       company: company
      });


    if (callback) callback(); // Call success callback if provided
  } catch (error) {
    console.error("Login failed:", error.response?.data || error.message);
    
    if (callback) callback(error); // Pass error to callback
  }
  finally{
    setCredLoading(false)
  }
}
  
  //  Login function
  const login = async (credentials,callback) => {
    setCredLoading(true)
    if(credLoading)return
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_URL+"/auth/token/",
         credentials,
         //{ withCredentials: true } No need im not using session auth
        );

  
      const { access, refresh, user } = response.data;
      //const { key } = response.data;
     
    
      localStorage.setItem("authToken", access);
      localStorage.setItem("refreshToken", refresh);
   /*
       Done in useEffect
      localStorage.setItem("id", user.id);
      localStorage.setItem("name", user.name);
      localStorage.setItem("email", user.email);
      localStorage.setItem("role", capitalizeFirstLetter(user.role));
      localStorage.setItem("type", user.type);
      localStorage.setItem("idcompany",user.company.id)
   
        */


   
      setUser((prevUser) => ({
        name:user.name ,
        role:capitalizeFirstLetter(user.role),
        type:user.type,
        super:user.super,
        email:user.email, // Preserve existing user data
        token: access, // Update only the token
        company: user.company,
      }));



   
      if (callback) callback(); // Call success callback if provided
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      
      if (callback) callback(error); // Pass error to callback
    }
    finally{
      setCredLoading(false)
    }
  };

   
  //  Logout function
  const logout = async () => {
  
    setCredLoading(true)
    if(credLoading)return
   
    
    try {
     
      const response = await axios.post(process.env.REACT_APP_BASE_URL+"/auth/logout/", 
        { refresh: localStorage.getItem("refreshToken") }, // Don't stringify
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    
      const data = response.data;
      //const { key } = response.data;
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("role");
      localStorage.removeItem("type"),
      localStorage.removeItem("id"),
      localStorage.removeItem("sideBarVendor")
      localStorage.removeItem("logo");
      localStorage.removeItem("idcompany")
      localStorage.removeItem("company_name")
      localStorage.removeItem("is_premium")
      localStorage.removeItem("country")
      localStorage.removeItem("super")

      

      setUser(null);
      //window.location.href = "/login"; 



   
     // if (callback) callback(); // Call success callback if provided
    } catch (error) {
      console.error("logout failed:", error.response?.data || error.message);
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("role");
      localStorage.removeItem("type");
      localStorage.removeItem("id");
      localStorage.removeItem("sideBarVendor")
      localStorage.removeItem("logo");
      localStorage.removeItem("idcompany");
      localStorage.removeItem("company_name")
      localStorage.removeItem("is_premium")
      localStorage.removeItem("country")
      localStorage.removeItem("super")


      //location.href = "/";
      //alert("Error , please try again")
      //if (callback) callback(error); // Pass error to callback
    }
    finally{
     setCredLoading(false)
     }
    
    
  };
  const capitalizeFirstLetter = (str) =>{
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return (
    <AuthContext.Provider value={{ user,setUser,register, login, logout, loading , credLoading}}>
      {children}
    </AuthContext.Provider>
  );
};
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useAuth = () => useContext(AuthContext);
